// var login_form = document.querySelector('.login-form');
// var recover_form =  document.querySelector('.recover-form');
// if(login_form &&  recover_form){
//   document.querySelector('.enable-login').addEventListener('click',function(e){
//     e.preventDefault();
//     login_form.classList.remove('hide-form');
//     recover_form.classList.add('hide-form');
//   });
//   document.querySelector('.enable-forgot').addEventListener('click',function(e){
//     e.preventDefault();
//     login_form.classList.add('hide-form');
//     recover_form.classList.remove('hide-form');
//   });
// }
// document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
//   editbutton.addEventListener('click',function(e){
//     e.preventDefault();
//     var address_id = this.dataset.addressid;
//     document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
//       if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
//         editformdiv.classList.remove('active-form');
//       }
//     });
//     document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
//   });
// });
// if(document.querySelector('#AddressCountryNew')){
//   new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
//     hideElement: 'AddressProvinceContainerNew'
//   });
//   document.querySelectorAll('[data-address-country-select]').forEach((select) => {
//     const formId = select.dataset.formId;
//     new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
//       hideElement: `AddressProvinceContainer_${formId}`
//     });
//   });
// }
// document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
//   destroyButton.addEventListener('click',function(e){
//     var destroyId = this.dataset.destroy;
//     console.log(destroyId);
//     Shopify.postLink(
//       '/account/addresses/'+destroyId, 
//       {'parameters': {'_method': 'delete'}}
//     );
//   });
// });
// if(document.querySelector('.account-link')){
//   document.querySelector('.account-link').addEventListener('click',function(e){
//     document.querySelector('.account-page-active').classList.add('active');
//     document.querySelector('.account-left').style.display = 'none';
//   });
// }
// if(document.querySelector('.add-address')){
//   document.querySelector('.add-address').addEventListener('click',function(e){
//     document.getElementById('address_form_new').classList.toggle('active-open-form');
//   });
// }


var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    e.preventDefault();
    var destroyId = this.dataset.destroy;
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}
if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    document.getElementById('address_form_new').classList.add('active-form');
  });
}
if(document.querySelectorAll('.cancel_active')) document.querySelectorAll('.cancel_active').forEach(function (close){
  close.addEventListener("click", function (e) {
    e.preventDefault();
    if(document.getElementById('address_form_new').classList.contains('active-form')) document.getElementById('address_form_new').classList.remove('active-form');
    if(document.querySelectorAll('.address-edit-form')) document.querySelectorAll('.address-edit-form').forEach(function (edit_form){
      if(edit_form.classList.contains('active-form')) edit_form.classList.remove('active-form');
    });
  });
});
if(document.querySelectorAll(".address-list .non-active-default")) document.querySelectorAll(".address-list .non-active-default").forEach(function (ele) {
  ele.addEventListener("click", function (e) {
    e.preventDefault();
    var dataId = this.getAttribute("data-id-id");
    var addForms = document.querySelectorAll(".address-form .address-edit-form");

    addForms.forEach(function (newAddress) {
      var addressId = newAddress.getAttribute("data-id");
      console.log("addressId", addressId, dataId);

      if (dataId === addressId) {
        var checkboxes = document.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach(function (checkbox) {
          checkbox.checked = true;
        });

        var form = newAddress.querySelector("form");
        if (form) {
          form.submit();
          console.log("Form submitted successfully");
        } else {
          console.log("Error: Form not found");
        }
      }
    });
  });
});

if(document.querySelectorAll('.ol-left li')) document.querySelectorAll('.ol-left li').forEach(li => {
  li.addEventListener('click', function() {
    let id = this.getAttribute('data-id');
    document.querySelectorAll('.ol-left li').forEach(item => {
      item.classList.remove('active');
    });
    this.classList.add('active');
    document.querySelectorAll('.ol-rgt-inr').forEach(rgt => {
      rgt.classList.remove('active-order-list');
    });
    let target = document.querySelector(`.ol-rgt-inr[data-id="${id}"]`);
    if (target) target.classList.add('active-order-list');
  });
});
if(document.querySelectorAll('.ol-rgt-inr .ol-mb-head')) document.querySelectorAll('.ol-rgt-inr .ol-mb-head').forEach(li => {
  li.addEventListener('click', function() {
    document.querySelectorAll('.ol-rgt-inr').forEach(rgt => {
      rgt.querySelector('.ol-rgt-wrap').style.maxHeight = '';
      rgt.classList.remove('active-order-list');
    });
    li.closest('.ol-rgt-inr').querySelector('.ol-rgt-wrap').style.maxHeight = li.closest('.ol-rgt-inr').querySelector('.ol-rgt-wrapper').clientHeight + 'px';
    li.closest('.ol-rgt-inr').classList.add('active-order-list');
  });
});
if(document.querySelectorAll('.mb-order-close')) document.querySelectorAll('.mb-order-close').forEach(close => {
  close.addEventListener('click', function(e){
    e.preventDefault();
    close.closest('.ol-rgt-inr').classList.remove('active-order-list');
    close.closest('.ol-rgt-inr').querySelector('.ol-rgt-wrap').style.maxHeight = '';
  });
});



document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form[action="/account/login"]');
  if (form) {
    form.addEventListener('submit', function() {
      sessionStorage.setItem('redirectAfterLogin', '/pages/rewards');
    });
  }
  if (window.location.pathname === '/account' && sessionStorage.getItem('redirectAfterLogin')) {
    sessionStorage.removeItem('redirectAfterLogin');
    window.location.href = '/pages/rewards';
  }
});


// document.addEventListener('DOMContentLoaded', function () {
//   const regForm = document.querySelector('form[action="/account"]');
//   if (regForm) {
//     regForm.addEventListener('submit', function () {
//       const returnInput = document.createElement('input');
//       returnInput.type = 'hidden';
//       returnInput.name = 'return_to';
//       returnInput.value = '/pages/rewards';
//       regForm.appendChild(returnInput);
//     });
//   }
// });


  // if (window.location.pathname === '/pages/rewards') {
  //   if (shouldRedirect) {
  //     setTimeout(function () {
  //       cartDrawerUpdate();
  //     }, 10000);
  //   }
  // }

// function cartDrawerUpdate() {
//   var url = window.location.href;
//   fetch(url)
//    .then(response => response.text())
//    .then(html => {
//     var parser = new DOMParser();
//     var doc = parser.parseFromString(html, 'text/html');
//     if (doc.querySelector('.rewards-left-inr') != null) {
//       alert('dfdf')
//      var mainSectionContent = doc.querySelector('.rewards-left-inr').innerHTML;
//      document.querySelector('.rewards-left-inr').innerHTML = mainSectionContent;
//     }
//    })
//    .catch(error => {
//     console.error('Error fetching collection main section:', error);
//    });
//  }



// document.addEventListener('DOMContentLoaded', function () {
//   const regForm = document.querySelector('form[action="/account"] , form[action="/account/register"] , form[action="/account/create"]');
//   if (regForm) {
//     regForm.addEventListener('submit', function () {
//       localStorage.setItem('redirectAfterReg', '/pages/rewards');
//     });
//   }
//   setTimeout(function() {
//     const shouldRedirect = localStorage.getItem('redirectAfterReg');
//     if (shouldRedirect) {
//       if (window.location.pathname === '/' || window.location.pathname === '/account') {
//           localStorage.removeItem('redirectAfterReg');
//           window.location.href = '/pages/rewards';
//       }
//     }
//   }, 100);
// });


// document.addEventListener('DOMContentLoaded', function() {
//     setTimeout(function() {
//       const form = document.querySelector('form[action="/account"]');
//       if (form) {
//         form.addEventListener('submit', function() {
//           alert('submit');
//           localStorage.setItem('redirectAfterLogin', '/pages/rewards');
//           alert('after');
//         });
//       }
//       const redirectFlag = localStorage.getItem('redirectAfterLogin');
//       if (redirectFlag) {
//         if (window.location.pathname === '/account' || window.location.pathname === '/') {
//           window.location.href = '/pages/rewards';
//           localStorage.removeItem('redirectAfterLogin');
//         }
//       }
//   }, 1000);
// });




// function countryCodeToEmoji(code) {
//   return Array.from(code.toUpperCase()).map(c =>
//     String.fromCodePoint(127397 + c.charCodeAt(0))
//   ).join('');
// }
// const countries = [
//   ["US", "United States"],
//   ["CA", "Canada"],
//   ["GB", "United Kingdom"],
//   ["DE", "Germany"],
//   ["FR", "France"],
//   ["ES", "Spain"],
//   ["IT", "Italy"],
//   ["NL", "Netherlands"],
//   ["BE", "Belgium"],
//   ["SE", "Sweden"],
//   ["NO", "Norway"],
//   ["DK", "Denmark"],
//   ["FI", "Finland"],
//   ["IE", "Ireland"],
//   ["PT", "Portugal"],
//   ["CH", "Switzerland"],
//   ["AT", "Austria"],
//   ["PL", "Poland"],
//   ["CZ", "Czech Republic"],
//   ["HU", "Hungary"],
//   ["GR", "Greece"],
//   ["TR", "Turkey"],
//   ["RU", "Russia"],
//   ["UA", "Ukraine"],
//   ["RO", "Romania"],
//   ["BG", "Bulgaria"],
//   ["HR", "Croatia"],
//   ["SI", "Slovenia"],
//   ["SK", "Slovakia"],
//   ["IS", "Iceland"],
//   ["LI", "Liechtenstein"],
//   ["BR", "Brazil"],
//   ["AR", "Argentina"],
//   ["CL", "Chile"],
//   ["CO", "Colombia"],
//   ["MX", "Mexico"],
//   ["PE", "Peru"],
//   ["VE", "Venezuela"],
//   ["UY", "Uruguay"],
//   ["CN", "China"],
//   ["JP", "Japan"],
//   ["KR", "South Korea"],
//   ["IN", "India"],
//   ["PK", "Pakistan"],
//   ["BD", "Bangladesh"],
//   ["LK", "Sri Lanka"],
//   ["NP", "Nepal"],
//   ["SG", "Singapore"],
//   ["MY", "Malaysia"],
//   ["ID", "Indonesia"],
//   ["PH", "Philippines"],
//   ["TH", "Thailand"],
//   ["VN", "Vietnam"],
//   ["ZA", "South Africa"],
//   ["NG", "Nigeria"],
//   ["EG", "Egypt"],
//   ["KE", "Kenya"],
//   ["MA", "Morocco"],
//   ["TN", "Tunisia"],
//   ["DZ", "Algeria"],
//   ["AU", "Australia"],
//   ["NZ", "New Zealand"],
//   ["IL", "Israel"],
//   ["SA", "Saudi Arabia"],
//   ["AE", "United Arab Emirates"],
//   ["IR", "Iran"],
//   ["IQ", "Iraq"]
// ];
// document.querySelectorAll('#countrySelect').forEach(select => {
//   countries.forEach(([code, name]) => {
//     const opt = document.createElement('option');
//     opt.value = code;
//     opt.textContent = countryCodeToEmoji(code);
//     opt.title = name;
//     opt.setAttribute('aria-label', name);
//     select.appendChild(opt);
//   });
//   select.selectedIndex = 0;
//   select.addEventListener('change', () => {
//     const code = select.value;
//     const name = select.options[select.selectedIndex].title;
//     console.log('Selected:', code, name);
//   });
// });

// ====================

// function countryCodeToEmoji(code) {
//   return Array.from(code.toUpperCase()).map(c =>
//     String.fromCodePoint(127397 + c.charCodeAt(0))
//   ).join('');
// }
// const countries = [
//   ["AF", "Afghanistan"], ["AL", "Albania"], ["DZ", "Algeria"], ["AD", "Andorra"], ["AO", "Angola"],
//   ["AG", "Antigua and Barbuda"], ["AR", "Argentina"], ["AM", "Armenia"], ["AU", "Australia"], ["AT", "Austria"],
//   ["AZ", "Azerbaijan"], ["BS", "Bahamas"], ["BH", "Bahrain"], ["BD", "Bangladesh"], ["BB", "Barbados"],
//   ["BY", "Belarus"], ["BE", "Belgium"], ["BZ", "Belize"], ["BJ", "Benin"], ["BT", "Bhutan"],
//   ["BO", "Bolivia"], ["BA", "Bosnia and Herzegovina"], ["BW", "Botswana"], ["BR", "Brazil"], ["BN", "Brunei"],
//   ["BG", "Bulgaria"], ["BF", "Burkina Faso"], ["BI", "Burundi"], ["CV", "Cabo Verde"], ["KH", "Cambodia"],
//   ["CM", "Cameroon"], ["CA", "Canada"], ["CF", "Central African Republic"], ["TD", "Chad"], ["CL", "Chile"],
//   ["CN", "China"], ["CO", "Colombia"], ["KM", "Comoros"], ["CG", "Congo"], ["CD", "Congo (Democratic Republic)"],
//   ["CR", "Costa Rica"], ["CI", "Côte d’Ivoire"], ["HR", "Croatia"], ["CU", "Cuba"], ["CY", "Cyprus"],
//   ["CZ", "Czech Republic"], ["DK", "Denmark"], ["DJ", "Djibouti"], ["DM", "Dominica"], ["DO", "Dominican Republic"],
//   ["EC", "Ecuador"], ["EG", "Egypt"], ["SV", "El Salvador"], ["GQ", "Equatorial Guinea"], ["ER", "Eritrea"],
//   ["EE", "Estonia"], ["SZ", "Eswatini"], ["ET", "Ethiopia"], ["FJ", "Fiji"], ["FI", "Finland"],
//   ["FR", "France"], ["GA", "Gabon"], ["GM", "Gambia"], ["GE", "Georgia"], ["DE", "Germany"],
//   ["GH", "Ghana"], ["GR", "Greece"], ["GD", "Grenada"], ["GT", "Guatemala"], ["GN", "Guinea"],
//   ["GW", "Guinea-Bissau"], ["GY", "Guyana"], ["HT", "Haiti"], ["HN", "Honduras"], ["HU", "Hungary"],
//   ["IS", "Iceland"], ["IN", "India"], ["ID", "Indonesia"], ["IR", "Iran"], ["IQ", "Iraq"],
//   ["IE", "Ireland"], ["IL", "Israel"], ["IT", "Italy"], ["JM", "Jamaica"], ["JP", "Japan"],
//   ["JO", "Jordan"], ["KZ", "Kazakhstan"], ["KE", "Kenya"], ["KI", "Kiribati"], ["KR", "South Korea"],
//   ["KW", "Kuwait"], ["KG", "Kyrgyzstan"], ["LA", "Laos"], ["LV", "Latvia"], ["LB", "Lebanon"],
//   ["LS", "Lesotho"], ["LR", "Liberia"], ["LY", "Libya"], ["LI", "Liechtenstein"], ["LT", "Lithuania"],
//   ["LU", "Luxembourg"], ["MG", "Madagascar"], ["MW", "Malawi"], ["MY", "Malaysia"], ["MV", "Maldives"],
//   ["ML", "Mali"], ["MT", "Malta"], ["MH", "Marshall Islands"], ["MR", "Mauritania"], ["MU", "Mauritius"],
//   ["MX", "Mexico"], ["FM", "Micronesia"], ["MD", "Moldova"], ["MC", "Monaco"], ["MN", "Mongolia"],
//   ["ME", "Montenegro"], ["MA", "Morocco"], ["MZ", "Mozambique"], ["MM", "Myanmar"], ["NA", "Namibia"],
//   ["NR", "Nauru"], ["NP", "Nepal"], ["NL", "Netherlands"], ["NZ", "New Zealand"], ["NI", "Nicaragua"],
//   ["NE", "Niger"], ["NG", "Nigeria"], ["MK", "North Macedonia"], ["NO", "Norway"], ["OM", "Oman"],
//   ["PK", "Pakistan"], ["PW", "Palau"], ["PA", "Panama"], ["PG", "Papua New Guinea"], ["PY", "Paraguay"],
//   ["PE", "Peru"], ["PH", "Philippines"], ["PL", "Poland"], ["PT", "Portugal"], ["QA", "Qatar"],
//   ["RO", "Romania"], ["RU", "Russia"], ["RW", "Rwanda"], ["KN", "Saint Kitts and Nevis"], ["LC", "Saint Lucia"],
//   ["VC", "Saint Vincent and the Grenadines"], ["WS", "Samoa"], ["SM", "San Marino"], ["ST", "Sao Tome and Principe"], ["SA", "Saudi Arabia"],
//   ["SN", "Senegal"], ["RS", "Serbia"], ["SC", "Seychelles"], ["SL", "Sierra Leone"], ["SG", "Singapore"],
//   ["SK", "Slovakia"], ["SI", "Slovenia"], ["SB", "Solomon Islands"], ["SO", "Somalia"], ["ZA", "South Africa"],
//   ["SS", "South Sudan"], ["ES", "Spain"], ["LK", "Sri Lanka"], ["SD", "Sudan"], ["SR", "Suriname"],
//   ["SE", "Sweden"], ["CH", "Switzerland"], ["SY", "Syria"], ["TW", "Taiwan"], ["TJ", "Tajikistan"],
//   ["TZ", "Tanzania"], ["TH", "Thailand"], ["TL", "Timor-Leste"], ["TG", "Togo"], ["TO", "Tonga"],
//   ["TT", "Trinidad and Tobago"], ["TN", "Tunisia"], ["TR", "Turkey"], ["TM", "Turkmenistan"], ["TV", "Tuvalu"],
//   ["UG", "Uganda"], ["UA", "Ukraine"], ["AE", "United Arab Emirates"], ["GB", "United Kingdom"], ["US", "United States"],
//   ["UY", "Uruguay"], ["UZ", "Uzbekistan"], ["VU", "Vanuatu"], ["VA", "Vatican City"], ["VE", "Venezuela"],
//   ["VN", "Vietnam"], ["YE", "Yemen"], ["ZM", "Zambia"], ["ZW", "Zimbabwe"]
// ];

// document.addEventListener("DOMContentLoaded", function() {
//   const mainSelect = document.getElementById("AddressCountryNew");
//   const flagSelect = document.getElementById("countrySelect");
//   countries.forEach(([code, name]) => {
//     const opt = document.createElement("option");
//     opt.value = code;
//     opt.textContent = countryCodeToEmoji(code); // ✅ only flag
//     opt.title = name; // tooltip shows name
//     flagSelect.appendChild(opt);
//   });
//   function syncMainToFlag() {
//     const val = mainSelect.value;
//     flagSelect.value = val;

//     if (!flagSelect.value) {
//       const selectedText = mainSelect.options[mainSelect.selectedIndex]?.text?.trim().toLowerCase();
//       for (let opt of flagSelect.options) {
//         if (opt.title.toLowerCase() === selectedText) {
//           flagSelect.value = opt.value;
//           break;
//         }
//       }
//     }
//   }
//   function syncFlagToMain() {
//     const val = flagSelect.value;
//     mainSelect.value = val;
//     if (!mainSelect.value) {
//       const selectedTitle = flagSelect.options[flagSelect.selectedIndex]?.title?.trim().toLowerCase();
//       for (let opt of mainSelect.options) {
//         if (opt.text.trim().toLowerCase() === selectedTitle) {
//           mainSelect.value = opt.value;
//           break;
//         }
//       }
//     }

//     mainSelect.dispatchEvent(new Event("change"));
//   }
//   mainSelect.addEventListener("change", () => {
//     syncMainToFlag();
//   });
//   flagSelect.addEventListener("change", () => {
//     syncFlagToMain();
//   });
//   syncMainToFlag();
// });


// ====================================================


// function countryCodeToEmoji(code) {
//   return Array.from(code.toUpperCase()).map(c =>
//     String.fromCodePoint(127397 + c.charCodeAt(0))
//   ).join('');
// }

// // 🌍 Country list with phone codes
// const countries = [
//   ["AF", "Afghanistan", "+93"], ["AL", "Albania", "+355"], ["DZ", "Algeria", "+213"], ["AD", "Andorra", "+376"], ["AO", "Angola", "+244"],
//   ["AR", "Argentina", "+54"], ["AM", "Armenia", "+374"], ["AU", "Australia", "+61"], ["AT", "Austria", "+43"], ["AZ", "Azerbaijan", "+994"],
//   ["BH", "Bahrain", "+973"], ["BD", "Bangladesh", "+880"], ["BY", "Belarus", "+375"], ["BE", "Belgium", "+32"], ["BT", "Bhutan", "+975"],
//   ["BR", "Brazil", "+55"], ["BG", "Bulgaria", "+359"], ["CA", "Canada", "+1"], ["CL", "Chile", "+56"], ["CN", "China", "+86"],
//   ["CO", "Colombia", "+57"], ["CR", "Costa Rica", "+506"], ["HR", "Croatia", "+385"], ["CY", "Cyprus", "+357"], ["CZ", "Czech Republic", "+420"],
//   ["DK", "Denmark", "+45"], ["EG", "Egypt", "+20"], ["EE", "Estonia", "+372"], ["FI", "Finland", "+358"], ["FR", "France", "+33"],
//   ["DE", "Germany", "+49"], ["GR", "Greece", "+30"], ["HK", "Hong Kong", "+852"], ["HU", "Hungary", "+36"], ["IS", "Iceland", "+354"],
//   ["IN", "India", "+91"], ["ID", "Indonesia", "+62"], ["IR", "Iran", "+98"], ["IQ", "Iraq", "+964"], ["IE", "Ireland", "+353"],
//   ["IL", "Israel", "+972"], ["IT", "Italy", "+39"], ["JP", "Japan", "+81"], ["JO", "Jordan", "+962"], ["KE", "Kenya", "+254"],
//   ["KW", "Kuwait", "+965"], ["LB", "Lebanon", "+961"], ["LU", "Luxembourg", "+352"], ["MY", "Malaysia", "+60"], ["MV", "Maldives", "+960"],
//   ["MT", "Malta", "+356"], ["MX", "Mexico", "+52"], ["MA", "Morocco", "+212"], ["NP", "Nepal", "+977"], ["NL", "Netherlands", "+31"],
//   ["NZ", "New Zealand", "+64"], ["NG", "Nigeria", "+234"], ["NO", "Norway", "+47"], ["OM", "Oman", "+968"], ["PK", "Pakistan", "+92"],
//   ["PH", "Philippines", "+63"], ["PL", "Poland", "+48"], ["PT", "Portugal", "+351"], ["QA", "Qatar", "+974"], ["RO", "Romania", "+40"],
//   ["RU", "Russia", "+7"], ["SA", "Saudi Arabia", "+966"], ["SG", "Singapore", "+65"], ["ZA", "South Africa", "+27"], ["KR", "South Korea", "+82"],
//   ["ES", "Spain", "+34"], ["LK", "Sri Lanka", "+94"], ["SE", "Sweden", "+46"], ["CH", "Switzerland", "+41"], ["TW", "Taiwan", "+886"],
//   ["TH", "Thailand", "+66"], ["TR", "Turkey", "+90"], ["UA", "Ukraine", "+380"], ["AE", "United Arab Emirates", "+971"], ["GB", "United Kingdom", "+44"],
//   ["US", "United States", "+1"], ["VN", "Vietnam", "+84"], ["YE", "Yemen", "+967"], ["ZM", "Zambia", "+260"], ["ZW", "Zimbabwe", "+263"]
// ];

// document.addEventListener("DOMContentLoaded", function() {
//   // Run logic for each form
//   document.querySelectorAll("form").forEach(form => {
//     const mainSelect = form.querySelector("#AddressCountryNew, select[name='address[country]']");
//     const flagSelect = form.querySelector("#countrySelect, select[name='address[country2]']");
//     const phoneInput = form.querySelector("#AddressPhoneNew, input[name='address[phone]']");

//     if (mainSelect && flagSelect) {
//       // Populate flag select
//       flagSelect.innerHTML = "";
//       countries.forEach(([code, name, dial]) => {
//         const opt = document.createElement("option");
//         opt.value = code;
//         opt.textContent = countryCodeToEmoji(code); // flag only
//         opt.title = name;
//         opt.dataset.dial = dial; // store dial code for later use
//         flagSelect.appendChild(opt);
//       });

//       // Helper: get dial code for country
//       function getDialCode(countryCode) {
//         const found = countries.find(c => c[0] === countryCode);
//         return found ? found[2] : "";
//       }

//       // --- Sync main → flag ---
//       function syncMainToFlag() {
//         const val = mainSelect.value;
//         flagSelect.value = val;
//         if (!flagSelect.value) {
//           const selectedText = mainSelect.options[mainSelect.selectedIndex]?.text?.trim().toLowerCase();
//           for (let opt of flagSelect.options) {
//             if (opt.title.toLowerCase() === selectedText) {
//               flagSelect.value = opt.value;
//               break;
//             }
//           }
//         }
//         updatePhoneCode(flagSelect.value);
//       }

//       // --- Sync flag → main ---
//       function syncFlagToMain() {
//         const val = flagSelect.value;
//         mainSelect.value = val;
//         if (!mainSelect.value) {
//           const selectedTitle = flagSelect.options[flagSelect.selectedIndex]?.title?.trim().toLowerCase();
//           for (let opt of mainSelect.options) {
//             if (opt.text.trim().toLowerCase() === selectedTitle) {
//               mainSelect.value = opt.value;
//               break;
//             }
//           }
//         }
//         mainSelect.dispatchEvent(new Event("change"));
//         updatePhoneCode(val);
//       }

//       // --- Update phone input ---
//       function updatePhoneCode(countryCode) {
//         if (!phoneInput) return;
//         const dial = getDialCode(countryCode);
//         if (dial && !phoneInput.value.startsWith(dial)) {
//           phoneInput.value = dial + " "; // add space for typing
//         }
//       }

//       // Add listeners
//       mainSelect.addEventListener("change", syncMainToFlag);
//       flagSelect.addEventListener("change", syncFlagToMain);

//       // Initial sync on load
//       syncMainToFlag();
//     }
//   });
// });

// =====================================================================

function countryCodeToEmoji(code) {
  return Array.from(code.toUpperCase()).map(c =>
    String.fromCodePoint(127397 + c.charCodeAt(0))
  ).join('');
}

// 🌍 Country list with phone codes
const countries = [
  ["AF", "Afghanistan", "+93"], ["AL", "Albania", "+355"], ["DZ", "Algeria", "+213"], ["AD", "Andorra", "+376"], ["AO", "Angola", "+244"],
  ["AR", "Argentina", "+54"], ["AM", "Armenia", "+374"], ["AU", "Australia", "+61"], ["AT", "Austria", "+43"], ["AZ", "Azerbaijan", "+994"],
  ["BH", "Bahrain", "+973"], ["BD", "Bangladesh", "+880"], ["BY", "Belarus", "+375"], ["BE", "Belgium", "+32"], ["BT", "Bhutan", "+975"],
  ["BR", "Brazil", "+55"], ["BG", "Bulgaria", "+359"], ["CA", "Canada", "+1"], ["CL", "Chile", "+56"], ["CN", "China", "+86"],
  ["CO", "Colombia", "+57"], ["CR", "Costa Rica", "+506"], ["HR", "Croatia", "+385"], ["CY", "Cyprus", "+357"], ["CZ", "Czech Republic", "+420"],
  ["DK", "Denmark", "+45"], ["EG", "Egypt", "+20"], ["EE", "Estonia", "+372"], ["FI", "Finland", "+358"], ["FR", "France", "+33"],
  ["DE", "Germany", "+49"], ["GR", "Greece", "+30"], ["HK", "Hong Kong", "+852"], ["HU", "Hungary", "+36"], ["IS", "Iceland", "+354"],
  ["IN", "India", "+91"], ["ID", "Indonesia", "+62"], ["IR", "Iran", "+98"], ["IQ", "Iraq", "+964"], ["IE", "Ireland", "+353"],
  ["IL", "Israel", "+972"], ["IT", "Italy", "+39"], ["JP", "Japan", "+81"], ["JO", "Jordan", "+962"], ["KE", "Kenya", "+254"],
  ["KW", "Kuwait", "+965"], ["LB", "Lebanon", "+961"], ["LU", "Luxembourg", "+352"], ["MY", "Malaysia", "+60"], ["MV", "Maldives", "+960"],
  ["MT", "Malta", "+356"], ["MX", "Mexico", "+52"], ["MA", "Morocco", "+212"], ["NP", "Nepal", "+977"], ["NL", "Netherlands", "+31"],
  ["NZ", "New Zealand", "+64"], ["NG", "Nigeria", "+234"], ["NO", "Norway", "+47"], ["OM", "Oman", "+968"], ["PK", "Pakistan", "+92"],
  ["PH", "Philippines", "+63"], ["PL", "Poland", "+48"], ["PT", "Portugal", "+351"], ["QA", "Qatar", "+974"], ["RO", "Romania", "+40"],
  ["RU", "Russia", "+7"], ["SA", "Saudi Arabia", "+966"], ["SG", "Singapore", "+65"], ["ZA", "South Africa", "+27"], ["KR", "South Korea", "+82"],
  ["ES", "Spain", "+34"], ["LK", "Sri Lanka", "+94"], ["SE", "Sweden", "+46"], ["CH", "Switzerland", "+41"], ["TW", "Taiwan", "+886"],
  ["TH", "Thailand", "+66"], ["TR", "Turkey", "+90"], ["UA", "Ukraine", "+380"], ["AE", "United Arab Emirates", "+971"], ["GB", "United Kingdom", "+44"],
  ["US", "United States", "+1"], ["VN", "Vietnam", "+84"], ["YE", "Yemen", "+967"], ["ZM", "Zambia", "+260"], ["ZW", "Zimbabwe", "+263"]
];

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("form").forEach(form => {
    const mainSelect = form.querySelector("#AddressCountryNew, select[name='address[country]']");
    const flagSelect = form.querySelector("#countrySelect, select[name='address[country2]']");
    const phoneInput = form.querySelector("#AddressPhoneNew, input[name='address[phone]']");

    if (mainSelect && flagSelect) {
      // Populate flag select
      flagSelect.innerHTML = "";
      countries.forEach(([code, name, dial]) => {
        const opt = document.createElement("option");
        opt.value = code;
        opt.textContent = countryCodeToEmoji(code);
        opt.title = name;
        opt.dataset.dial = dial;
        flagSelect.appendChild(opt);
      });

      function getDialCode(countryCode) {
        const found = countries.find(c => c[0] === countryCode);
        return found ? found[2] : "";
      }

      function syncMainToFlag() {
        const val = mainSelect.value;
        flagSelect.value = val;
        if (!flagSelect.value) {
          const selectedText = mainSelect.options[mainSelect.selectedIndex]?.text?.trim().toLowerCase();
          for (let opt of flagSelect.options) {
            if (opt.title.toLowerCase() === selectedText) {
              flagSelect.value = opt.value;
              break;
            }
          }
        }
        updatePhoneCode(flagSelect.value);
      }

      function syncFlagToMain() {
        const val = flagSelect.value;
        mainSelect.value = val;
        if (!mainSelect.value) {
          const selectedTitle = flagSelect.options[flagSelect.selectedIndex]?.title?.trim().toLowerCase();
          for (let opt of mainSelect.options) {
            if (opt.text.trim().toLowerCase() === selectedTitle) {
              mainSelect.value = opt.value;
              break;
            }
          }
        }
        mainSelect.dispatchEvent(new Event("change"));
        updatePhoneCode(val);
      }

      let currentDial = "";

      function updatePhoneCode(countryCode) {
        if (!phoneInput) return;
        const dial = getDialCode(countryCode);
        const prefix = dial + " ";
        if (!phoneInput.value.startsWith(prefix)) {
          phoneInput.value = prefix;
        }
        currentDial = prefix;
        setCaretToEnd();
      }

      function setCaretToEnd() {
        requestAnimationFrame(() => {
          if (phoneInput && currentDial) {
            const pos = Math.max(phoneInput.value.length, currentDial.length);
            phoneInput.setSelectionRange(pos, pos);
          }
        });
      }

      mainSelect.addEventListener("change", syncMainToFlag);
      flagSelect.addEventListener("change", syncFlagToMain);
      syncMainToFlag();

      // 🔒 Protect +code and 1-space prefix
      if (phoneInput) {
        phoneInput.addEventListener("beforeinput", e => {
          const start = phoneInput.selectionStart;
          if (start <= currentDial.length - 1) {
            e.preventDefault();
            setCaretToEnd();
          }
        });

        phoneInput.addEventListener("keydown", e => {
          const start = phoneInput.selectionStart;
          if (
            currentDial &&
            start <= currentDial.length - 1 &&
            (e.key === "Backspace" || e.key === "Delete" || e.key === "ArrowLeft")
          ) {
            e.preventDefault();
            setCaretToEnd();
          }
        });

        phoneInput.addEventListener("click", () => {
          if (phoneInput.selectionStart < currentDial.length) {
            setCaretToEnd();
          }
        });

        phoneInput.addEventListener("focus", setCaretToEnd);

        phoneInput.addEventListener("input", () => {
          // If prefix got broken (e.g., paste), fix it instantly
          if (!phoneInput.value.startsWith(currentDial)) {
            const newVal = phoneInput.value.replace(/^\+?\d*\s*/, "");
            phoneInput.value = currentDial + newVal;
          }
        });
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const birthdayInput = document.getElementById('RegisterForm-birthday');
  const birthdayError = document.getElementById('RegisterForm-birthday-error');
  
  if (birthdayInput) {
    let lastValue = '';
    
    birthdayInput.addEventListener('input', function(e) {
      let value = e.target.value;
      const cursorPosition = e.target.selectionStart;
      
      const isDeleting = value.length < lastValue.length;
      
      let digitsOnly = value.replace(/\D/g, '');
      
      let formatted = '';
      if (digitsOnly.length >= 1) {
        formatted = digitsOnly.substring(0, 2);
      }
      if (digitsOnly.length >= 3) {
        formatted += '/' + digitsOnly.substring(2, 4);
      }
      if (digitsOnly.length >= 5) {
        formatted += '/' + digitsOnly.substring(4, 8);
      }
      
      e.target.value = formatted;
      lastValue = formatted;
      
      if (!isDeleting && formatted.length > value.length) {
        const newPos = cursorPosition + (formatted.length - value.length);
        e.target.setSelectionRange(newPos, newPos);
      }
    });
    
    birthdayInput.addEventListener('blur', function() {
      const value = this.value.trim();
      
      if (!value) {
        birthdayError.style.display = 'none';
        this.setCustomValidity('');
        return;
      }
      
      const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const match = value.match(dateRegex);
      
      if (!match) {
        birthdayError.style.display = 'block';
        this.setCustomValidity('Invalid date format');
        return;
      }
      
      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10);
      const year = parseInt(match[3], 10);
      
      if (month < 1 || month > 12) {
        birthdayError.textContent = 'Month must be between 01 and 12';
        birthdayError.style.display = 'block';
        this.setCustomValidity('Invalid month');
        return;
      }
      
      const date = new Date(year, month - 1, day);
      const isValidDate = date.getFullYear() === year && 
                          date.getMonth() === month - 1 && 
                          date.getDate() === day;
      
      if (!isValidDate || day < 1 || day > 31) {
        birthdayError.textContent = 'Please enter a valid date';
        birthdayError.style.display = 'block';
        this.setCustomValidity('Invalid date');
        return;
      }
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (date > today) {
        birthdayError.textContent = 'Birthday cannot be in the future';
        birthdayError.style.display = 'block';
        this.setCustomValidity('Future date not allowed');
        return;
      }
      
      const minYear = today.getFullYear() - 120;
      if (year < minYear) {
        birthdayError.textContent = 'Please enter a valid birth year';
        birthdayError.style.display = 'block';
        this.setCustomValidity('Invalid year');
        return;
      }
      
      birthdayError.style.display = 'none';
      this.setCustomValidity('');
    });
    
    const form = birthdayInput.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        birthdayInput.dispatchEvent(new Event('blur'));
        if (birthdayInput.validity.customError) {
          e.preventDefault();
          birthdayInput.focus();
        }
      });
    }
  }
});



// document.addEventListener('DOMContentLoaded', function() {
//   const passwordField = document.getElementById('RegisterForm-password');
//   const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
//   if (passwordField && isIOS) {
//     passwordField.addEventListener('focus', function() {
//       this.type = 'text';
//     });
//     passwordField.addEventListener('blur', function() {
//       this.type = 'password';
//     });
//     const form = passwordField.closest('form');
//     if (form) {
//       form.addEventListener('submit', function() {
//         passwordField.type = 'password';
//       });
//     }
//   }
// });